export default `<svg
  xmlns="http://www.w3.org/2000/svg"
  viewBox="0 0 18 18"
  height="18"
  width="18"
  version="1.1"
>
  <path
     d="m 6.6694005,0.52115619 a 3.4958999,1.1653 0 0 0 0,1.16529261 0.93224201,1.1653025 0 0 1 0,2.3306049 A 3.4958999,1.1653 0 0 0 3.1735,5.1823562 V 16.83535 a 5.8265,1.1653 0 1 0 11.653,0 V 5.1823562 a 3.4958999,1.1653 0 0 0 -3.4959,-1.1653025 0.93224201,1.1653025 0 0 1 0,-2.3306049 3.4958999,1.1653 0 0 0 0,-1.16529261 2.79672,1.1653 0 0 0 -4.6611995,0"
  />
</svg>`;
